class FormValidator {
    constructor(el) {
        if (el.tagName === 'FORM') {
            this.el = el
        }  else if (el.querySelector('form')) {
            this.el = el.querySelector('form')
        } else {
            this.el = el.closest('form')
        }
        if (!this.el) {
            throw 'missing form elemnt'
        }
        this.validationElements = ['INPUT', 'SELECT']
        this.groups = this.el.querySelectorAll('[data-validator-group]')
        this.onChange = this.onChange.bind(this)
        this.validateAll = this.validateAll.bind(this)
        this.init()
    }

    init() {
        this.el.addEventListener('input', this.onChange)
        this.el.addEventListener('change', this.onChange)
        this.el.addEventListener('blur', this.onChange)
        document.addEventListener('tab_changed', this.validateAll)
        this.validateAll()
    }

    getInputs(el) {
        return el.querySelectorAll(this.validationElements.join(','))
    }

    onChange(e) {
        if (this.validationElements.indexOf(e.target.tagName) > -1) {
            this.validate(e.target)
            this.validateGroup(e.target)
            this.validateForm()
        }
    }

    validate(el) {
        const validators = this.getValidators(el)
        const isValid = validators.reduce((isValid, v) => {
            if (isValid) {
                isValid = v.fn(el)
            }
            return isValid
        }, true)

        if (!isValid) {
            el.dataset.validatorIsInvalid = ''
        } else {
            delete el.dataset.validatorIsInvalid
        }
    }

    validateAll(){
        const inputs = this.getInputs(this.el)
        inputs.forEach((el) => {
            this.validate(el)
        })
        inputs.forEach((el) => {
            this.validateGroup(el)
        })
        this.validateForm()
    }

    validateGroup(el) {
        const group = Array.from(this.groups).find((g) => g.contains(el))
        if (group) {
            const inputs = this.getInputs(group)
            inputs.forEach((el) => {
                this.validate(el)
            })
            const isValid = !group.querySelector('[data-validator-is-invalid]')
            if (!isValid) {
                group.dataset.validatorIsGroupInvalid = ''
            } else {
                delete group.dataset.validatorIsGroupInvalid
            }
        }
    }

    validateForm(){
        const isFormValid = !this.el.querySelector('[data-validator-is-group-invalid]')
        if (!isFormValid) {
            this.el.dataset.validatorIsFormInvalid = ''
        } else {
            delete this.el.dataset.validatorIsFormInvalid
        }
    }

    getValidators(el) {
        const validators = []
        if (el.type === 'hidden') {
            return validators
        }

        if(el.offsetParent === null){
            return validators
        }

        if (el.hasAttribute('required') || el.dataset.hasOwnProperty('validatorRequired')) {
            validators.push({
                fn: this.requiredValidator
            })
        }
        if (el.dataset.hasOwnProperty('validatorEmail')) {
            validators.push({
                fn: this.emailValidator
            })
        }

        return validators
    }

    requiredValidator(el) {
        return el.type === 'checkbox' ? el.checked : !!el.value
    }

    emailValidator(el) {
        const pattern = new RegExp(
            /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
        )
        return pattern.test(el.value)
    }
}

export default FormValidator
